import type { Config, tAPI } from "./API";
import Storage from "./Storage";
// API Files static class

const apiBaseFiles = "/files";
export default class Files {
  // Edit a file (v3 — delegates to Storage)
  static EditFile(api: tAPI, fileId: string, data: object, config?: Config) {
    return Storage.EditFile(api, fileId, data, config);
  }
  // Delete a file (v3 — delegates to Storage)
  static DeleteFile(api: tAPI, fileId: string, config?: Config) {
    return Storage.DeleteFile(api, fileId, config);
  }
  // Get signed download URL for a single file (v3)
  static GetDownloadUrl(api: tAPI, fileId: string, config?: Config) {
    return Storage.GetDownloadUrl(api, fileId, config);
  }
  // Download multiple files as archive (legacy v1 — kept for bulk downloads)
  static DownloadFiles(
    api: tAPI,
    data: object,
    extension: string,
    config?: Config
  ) {
    return api.DOWNLOAD(`${apiBaseFiles}/download`, data, extension, config);
  }
}
